module.exports = __webpack_public_path__ + "img/nft.a6ef7ce4.webp";